import axios from "axios";
import {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {Breadcrumb, Col, Modal, Pagination, Row, Input, message} from "antd";
import { getUserListening } from '../apis/userListening';
import Footer from "../component/Footer";
import CardItem from '../component/CardItem';
import {useCookies} from "react-cookie";
import dayjsInstance from "../utils/dayjs";

export default function Lesson() {

    const {slug} = useParams();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalSpeakOpen, setIsModalSpeakOpen] = useState(false);
    const [dataLesson, setdataLesson] = useState([]);
    const [dataUserTopic, setDataUserTopic] = useState({});
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 12,
    });
    const [cookies, setCookie, removeCookie] = useCookies(["user"]);
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState(null); // fresh user data from API (vip_expire_at)

    // Learning goals (course-level numeric targets)
    const goalStorageKey = `lesson_goal_course_${slug}`;
    const [goalDays, setGoalDays] = useState(() => {
        try { const v = JSON.parse(localStorage.getItem(goalStorageKey)); return v?.days || 30; } catch { return 30; }
    });
    const [goalHours, setGoalHours] = useState(() => {
        try { const v = JSON.parse(localStorage.getItem(goalStorageKey)); return v?.hours || 30; } catch { return 30; }
    });
    const [editingGoals, setEditingGoals] = useState(false);

    // older free-form goals list (kept for compatibility)
    const [goals, setGoals] = useState(() => {
        try { return JSON.parse(localStorage.getItem(`learning_goals_${slug}`)) || []; } catch { return []; }
    });
    const [goalInput, setGoalInput] = useState('');
    const [editGoalIndex, setEditGoalIndex] = useState(null);
    const [editGoalValue, setEditGoalValue] = useState('');

    const [userListenings, setUserListenings] = useState([]);

    const saveGoal = () => {
        const trimmed = goalInput.trim();
        if (!trimmed) return;
        const next = [...goals, { text: trimmed, done: false }];
        setGoals(next);
        localStorage.setItem(goalStorageKey, JSON.stringify(next));
        setGoalInput('');
        message.success('Đã thêm mục tiêu!');
    };

    const saveCourseGoals = (days, hours) => {
        const obj = { days: Number(days || 0), hours: Number(hours || 0) };
        try {
            localStorage.setItem(goalStorageKey, JSON.stringify(obj));
            setGoalDays(obj.days); setGoalHours(obj.hours);
            message.success('Đã lưu mục tiêu cho khoá học');
        } catch (e) { console.error(e); message.error('Không thể lưu mục tiêu'); }
    };

    const toggleGoal = (i) => {
        const next = goals.map((g, idx) => idx === i ? { ...g, done: !g.done } : g);
        setGoals(next);
        localStorage.setItem(goalStorageKey, JSON.stringify(next));
    };

    const deleteGoal = (i) => {
        const next = goals.filter((_, idx) => idx !== i);
        setGoals(next);
        localStorage.setItem(goalStorageKey, JSON.stringify(next));
    };

    const startEditGoal = (i) => {
        setEditGoalIndex(i);
        setEditGoalValue(goals[i].text);
    };

    const saveEditGoal = () => {
        if (!editGoalValue.trim()) return;
        const next = goals.map((g, idx) => idx === editGoalIndex ? { ...g, text: editGoalValue.trim() } : g);
        setGoals(next);
        localStorage.setItem(goalStorageKey, JSON.stringify(next));
        setEditGoalIndex(null);
        setEditGoalValue('');
    };

    const lesson = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/lesson/getBySlugCourse/${slug}`, {params: pagination});
            const courseData = response?.data[0];
            setdataLesson(courseData);
            // if duration missing on lessons, try to fetch first audio metadata to set duration in UI
            try {
                const lessonsArr = courseData?.lesson || [];
                lessonsArr.forEach((lsn, idx) => {
                    if (!lsn) return;
                    if (lsn.duration && Number(lsn.duration) > 0) return; // already present
                    const candidates = [
                        lsn.main_story_audio, lsn.mainStoryAudio, lsn.main_audio, lsn.mainStoryUrl, lsn.main_story_url,
                        lsn.vocabulary_audio, lsn.vocabularyAudio,
                        lsn.mini_story_audio, lsn.miniStoryAudio,
                        lsn.POV_audio, lsn.POVAudio, lsn.comment_audio, lsn.commentAudio
                    ];
                    let found = null;
                    for (const c of candidates) {
                        if (!c) continue;
                        if (typeof c === 'string' && /\.(mp3|m4a|wav|ogg|webm|aac)(\?.*)?$/i.test(c)) { found = c; break; }
                        if (Array.isArray(c) && c.length && typeof c[0] === 'string' && /\.(mp3|m4a|wav|ogg|webm|aac)(\?.*)?$/i.test(c[0])) { found = c[0]; break; }
                        if (c && typeof c === 'object' && typeof c.url === 'string' && /\.(mp3|m4a|wav|ogg|webm|aac)(\?.*)?$/i.test(c.url)) { found = c.url; break; }
                    }
                    if (found) {
                        try {
                            const audio = new Audio();
                            audio.preload = 'metadata';
                            audio.crossOrigin = 'anonymous';
                            audio.src = proxyIfR2(found);
                            const onLoaded = () => {
                                try {
                                    const d = audio.duration;
                                    if (d && isFinite(d) && !isNaN(d) && d > 0) {
                                        setdataLesson(prev => {
                                            if (!prev) return prev;
                                            const next = { ...prev };
                                            if (Array.isArray(next.lesson) && next.lesson[idx]) {
                                                next.lesson = [...next.lesson];
                                                next.lesson[idx] = { ...next.lesson[idx], duration: Math.floor(d) };
                                            }
                                            return next;
                                        });
                                    }
                                } catch (e) {}
                                try { audio.removeEventListener('loadedmetadata', onLoaded); audio.src = ''; } catch (e) {}
                            };
                            const onError = () => { try { audio.removeEventListener('error', onError); audio.src = ''; } catch (e) {} };
                            audio.addEventListener('loadedmetadata', onLoaded);
                            audio.addEventListener('error', onError);
                        } catch (e) {}
                    }
                });
            } catch (e) { console.error('Fetch lesson durations error', e); }
        } catch (error) {
            console.error(error);
        }
    }

    const fetchUserInfo = async () => {
        if (!cookies?.user?.token) return;
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/me`, {
                headers: {
                    'Authorization': `Bearer ${cookies?.user?.token}`
                }
            });
            setUserInfo(response.data);
        } catch (error) {
            console.error('Error fetching user info:', error);
        }
    };

    const userTopic = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/usertopic`, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${cookies?.user?.token}`
                }
            });
            setDataUserTopic(response?.data[0]);
        } catch (error) {
            console.error(error);
        }
    }

    const proxyIfR2 = (u) => {
        if (!u || typeof u !== 'string') return u;
        if (u.includes('.r2.cloudflarestorage.com')) {
            const proxyBase = (process.env.REACT_APP_API_URL || '');
            return `${proxyBase.replace(/\/$/, '')}/media/proxy?url=${encodeURIComponent(u)}`;
        }
        return u;
    }

    const formatSeconds = (s) => {
        const secNum = Number(s) || 0;
        const sec = Math.floor(secNum);
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const ss = sec % 60;
        if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
        return `${m}:${String(ss).padStart(2, '0')}`;
    }

    useEffect(() => {
        lesson();
        if (cookies?.user) {
            userTopic();
            fetchUserInfo();
            // fetch user's listening history for per-lesson stats
            (async () => {
                try {
                    const list = await getUserListening(cookies?.user?.token);
                    setUserListenings(list || []);
                } catch (e) { console.error('Fetch listenings error', e); }
            })();
        }
    }, [slug, cookies?.user, pagination.page, pagination.pageSize]);

    return (
        <>
            <div className="min-h-screen bg-[#0a1628] py-8">
                <div className="max-w-screen-2xl mx-auto p-6">
                    <Breadcrumb
                        className="py-5 [&_.ant-breadcrumb-link]:text-blue-400 [&_.ant-breadcrumb-separator]:text-gray-500 [&_a]:text-blue-400 [&_a:hover]:text-white"
                        items={[
                            {
                                title: <a href="/">Home</a>,
                            },
                            {
                                title: <a href="/topic">Topic</a>,
                            },
                            {
                                title: <span className="text-gray-300">{dataLesson?.title}</span>,
                            },
                        ]}
                    />

                    <div className="text-center mb-8">
                        <h1 className="text-4xl font-bold text-white">{dataLesson?.title}</h1>
                        <p className="text-sm text-gray-400 mt-2">Danh sách bài học — chọn Listening hoặc Speaking để bắt đầu</p>
                    </div>

                    {/* Learning Goals */}
                    <div className="mb-8 bg-[#1a2d4a] border border-white/10 rounded-2xl p-5">
                        <div className="flex items-center gap-2 mb-4">
                            <span className="text-xl">🎯</span>
                            <h2 className="text-white font-bold text-lg">Mục tiêu học tập</h2>
                            <div className="ml-auto text-right">
                                <p className="text-xs text-gray-400">Mục tiêu khóa</p>
                                <p className="text-white font-semibold">{goalDays} lần · {goalHours} giờ</p>
                            </div>
                        </div>


                        {/* Course numeric goals editor */}
                        <div className="mb-4">
                            <div className="bg-[#0f1e35] rounded-xl p-3 border border-white/5">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-gray-400 text-xs">Mục tiêu (sửa được)</p>
                                        <p className="text-white font-bold text-sm">{goalDays} lần · {goalHours} giờ</p>
                                    </div>
                                    <div>
                                        <button onClick={() => setEditingGoals(v => !v)} className="text-blue-300 hover:text-white">
                                            {editingGoals ? 'Huỷ' : 'Chỉnh'}
                                        </button>
                                    </div>
                                </div>

                                {editingGoals && (
                                    <div className="mt-3 flex gap-3 items-center">
                                        <input type="number" value={goalDays} onChange={e => setGoalDays(Number(e.target.value))}
                                            className="w-28 px-3 py-1 rounded bg-[#081226] text-white text-sm border border-white/10" />
                                        <span className="text-gray-400 text-sm">lần</span>
                                        <input type="number" value={goalHours} onChange={e => setGoalHours(Number(e.target.value))}
                                            className="w-28 px-3 py-1 rounded bg-[#081226] text-white text-sm border border-white/10" />
                                        <span className="text-gray-400 text-sm">giờ</span>
                                        <button onClick={() => { saveCourseGoals(goalDays, goalHours); setEditingGoals(false); }}
                                            className="px-3 py-1 rounded bg-cyan-500 text-white text-sm">Lưu</button>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Add new goal */}
                        <div className="flex gap-2">
                            <Input
                                value={goalInput}
                                onChange={e => setGoalInput(e.target.value)}
                                onPressEnter={saveGoal}
                                placeholder="Thêm mục tiêu học tập mới… (ví dụ: Hoàn thành 5 bài tuần này)"
                                className="bg-[#0f1e35] border-white/20 text-white placeholder:text-gray-500 flex-1 rounded-xl"
                            />
                            <button
                                onClick={saveGoal}
                                className="px-4 py-2 rounded-xl bg-blue-500 hover:bg-blue-600 text-white text-sm font-semibold transition-colors shadow-lg shadow-blue-500/20 whitespace-nowrap"
                            >
                                + Thêm
                            </button>
                        </div>
                    </div>

                    <Row gutter={[16, 16]}>
                        {dataLesson?.lesson?.map((lesson, index) => {
                            const vipExpireAt = userInfo?.vip_expire_at || cookies?.user?.vip_expire_at;
                            const hasVipAccess = (dayjsInstance(vipExpireAt)?.format("YYYY-MM-DD") > dayjsInstance(Date())?.format("YYYY-MM-DD") && vipExpireAt !== null);
                            const hasProgressUnlock = +dataUserTopic?.lesson_id >= +lesson.id;
                            const isFirstLesson = +index === 0;
                            // If lesson is marked as FREE (0), always unlocked. If VIP (1), check access
                            const unlocked = lesson.is_vip !== 1 || hasVipAccess || hasProgressUnlock || isFirstLesson;
                            // count only listenings that are >= 15 minutes as a session
                            const sessionsCount = (userListenings || []).filter(u => +u.lesson_id === +lesson.id && (Number(u.duration) || 0) >= 15 * 60).length;
                            // compute studied seconds for hours calculation
                            const studiedSeconds = (userListenings || []).filter(u => +u.lesson_id === +lesson.id).reduce((acc, it) => acc + (Number(it.duration) || 0), 0);
                            // per-lesson goal (check localStorage lesson-specific key)
                            let perLessonGoal = null;
                            try { const raw = localStorage.getItem(`lesson_goal_${lesson.id}`); perLessonGoal = raw ? JSON.parse(raw) : null; } catch (e) { perLessonGoal = null; }
                            const perLessonGoalDays = perLessonGoal?.days || null;
                            const perLessonGoalHours = perLessonGoal?.hours || null;
                            return (
                                <Col xs={24} sm={12} md={8} xl={6} key={index}>
                                    <CardItem
                                        to={unlocked ? ("/lesson/listening/" + lesson?.slug) : undefined}
                                        linkState={{index: index}}
                                        title={lesson.title}
                                        subtitle={lesson.description || ''}
                                        image={lesson?.lesson_url}
                                        imageAlt={lesson.title}
                                        badge={lesson.is_vip === 1 ? 'VIP' : ''}
                                        isVipLocked={!unlocked}
                                        progress={0}
                                        buttonLabel={unlocked ? 'Học ngay' : 'Mở khóa'}
                                        disabled={!unlocked}
                                        onClick={() => { if(!unlocked) setIsModalOpen(true); }}
                                        noLink={true}
                                        meta={`⏱ ${((lesson.duration && Number(lesson.duration) > 0) ? formatSeconds(lesson.duration) : (studiedSeconds && Number(studiedSeconds) > 0 ? formatSeconds(studiedSeconds) : '—'))}`}
                                        lessonGoalDays={perLessonGoalDays}
                                        lessonGoalHours={perLessonGoalHours}
                                        lessonDuration={(lesson.duration && Number(lesson.duration) > 0) ? Number(lesson.duration) : (studiedSeconds && Number(studiedSeconds) > 0 ? Number(studiedSeconds) : 0)}
                                        courseGoalDays={goalDays}
                                        courseGoalHours={goalHours}
                                        sessionsDone={sessionsCount}
                                        sessionsGoal={(perLessonGoalDays || goalDays)}
                                        hoursDone={Math.round((studiedSeconds / 3600) * 100) / 100}
                                        hoursGoal={(perLessonGoalHours || goalHours)}
                                        actions={(
                                            <div className='flex items-center gap-2 flex-wrap'>
                                                {unlocked ? (
                                                    <Link
                                                        to={"/lesson/listening/" + lesson?.slug}
                                                        state={{index: index}}
                                                        className='w-full'
                                                        onClick={e => e.stopPropagation()}
                                                    >
                                                        <span className='flex items-center justify-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-xl bg-blue-500 text-white hover:bg-blue-600 transition-all w-full shadow-lg shadow-blue-500/20'>
                                                            🎧 Học ngay
                                                        </span>
                                                    </Link>
                                                ) : (
                                                    <button
                                                        onClick={(e) => { e.stopPropagation(); setIsModalOpen(true); }}
                                                        className='w-full flex items-center justify-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-xl bg-white/5 text-gray-500 border border-white/10 cursor-not-allowed whitespace-nowrap'
                                                    >
                                                        � Mở khóa
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>
                            )
                        })}
                    </Row>

                    <Pagination
                        className="flex justify-center pt-[30px]"
                        current={pagination.page}
                        total={dataLesson?.total}
                        pageSize={pagination.pageSize}
                        onChange={(p, ps) => {
                            setPagination({
                                page: p,
                                pageSize: ps
                            })
                        }}
                    />

                </div>
            </div>
                
            {Footer()}

            <Modal open={isModalOpen}
                   onOk={() => cookies?.user ? navigate(`/profile/${cookies.user.id}`) : navigate('/login')}
                   onCancel={() => setIsModalOpen(false)} okButtonProps={{className: "bg-blue-500"}}>
                <p className="text-xl font-bold py-2 pt-8">Vui lòng truy cập vào profile và </p>
                <p className="text-xl font-bold py-2 pb-8">đăng ký gói vip để được sử dụng dịch vụ này</p>
            </Modal>

            <Modal open={isModalSpeakOpen} onOk={() => setIsModalSpeakOpen(false)}
                   onCancel={() => setIsModalSpeakOpen(false)} okButtonProps={{className: "bg-blue-500"}}>
                <p className="text-xl font-bold py-5 pt-8">Vui lòng tải app để được dùng chức năng này!</p>
            </Modal>
        </>
    );
};
